import './PieGraph.sass'
import {useEffect} from "react";

const PieGraph = ({data, width, id, borderColor, borderWidth}) => {

    useEffect(()=>{
        console.log("PieGraph ("+id+")");
        console.log("   data: ", data);
    },[data])

    const getGradientValues = () => {
        console.log("PieGraph["+id+"] getGradientValues(",data.fields,")");
        if(!data.fields) return "black"
        let s = "conic-gradient("
        let lastValue = 0;
        let pct = 0;
        data.fields.map((f, i) => {
            console.log("   f.id: ", f.id);
            s += f.color;
            if (i > 0) {
                s += " " + String(lastValue) + "deg"
            }
            pct = 360 * (Number(f.value) / 100);
            s += " " + String(pct + lastValue) + "deg"
            lastValue += pct
            if (i < data.fields.length - 1) {
                s += ", "
            }
            else{
                s+=")"
            }
            console.log("   s: ", s);
            
        })
        return s;
    }
    return (
        <div className="PieGraph"
             style={{
                 borderWidth: borderWidth?borderWidth:"2px",
                 borderColor: borderColor?borderColor:"white",
                 width: width ? width : "100px",
                 height: width ? width : "100px",
                 background: getGradientValues()
             }}>
        </div>
    );
}

export default PieGraph;